/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { defineComponent, onMounted, getCurrentInstance, createVNode } from 'vue';
import circleAdapter from '../../_common/js/loading/circle-adapter.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import '../../_chunks/dep-b011b919.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_common/js/utils/set-style.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-56ceb7ce.mjs';
import '../../_chunks/dep-2a2a0e63.mjs';
import '../../_chunks/dep-c3626417.mjs';
import '../../_chunks/dep-fc63c737.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-e00db566.mjs';
import '../../_chunks/dep-fdde96c5.mjs';
import '../../_chunks/dep-961339ce.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-99a0abba.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';

var GradientIcon = defineComponent({
  name: "TLoadingGradient",
  setup: function setup() {
    var classPrefix = usePrefixClass();
    onMounted(function () {
      var circleElem = getCurrentInstance().refs.circle;
      circleAdapter(circleElem);
    });
    return {
      classPrefix: classPrefix
    };
  },
  render: function render() {
    var classPrefix = this.classPrefix;
    var name = "".concat(classPrefix, "-loading__gradient");
    var classes = [name, "".concat(classPrefix, "-icon-loading")];
    return createVNode("svg", {
      "class": classes,
      "viewBox": "0 0 12 12",
      "version": "1.1",
      "width": "1em",
      "height": "1em",
      "xmlns": "http://www.w3.org/2000/svg"
    }, [createVNode("foreignObject", {
      "x": "0",
      "y": "0",
      "width": "12",
      "height": "12"
    }, [createVNode("div", {
      "class": "".concat(name, "-conic"),
      "ref": "circle"
    }, null)])]);
  }
});

export { GradientIcon as default };
//# sourceMappingURL=gradient.mjs.map
